import {Component, OnInit, ViewChild} from '@angular/core';
import {Page} from '../../model/page';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {permissions} from '../../permissions';
import {ImportHistoryService} from '../../services/importhistory.service';
import {PagedData} from '../../model/paged-data';
import {Observable} from 'rxjs/Observable';
import * as _ from 'lodash';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-import-history',
  templateUrl: './import-history.component.html',
  styleUrls: ['./import-history.component.scss'],
  providers: [
    ImportHistoryService
  ]
})
export class ImportHistoryComponent implements OnInit {

    @ViewChild('myTable')   table: any;

    public loading = false;
    public  permissions = permissions;

    private companies: Array<any> = [];
    private preloadedData: {};

    public selectedCategoryLabel: string;

    page = new Page();
    rows = new Array<object>();

    private filters: { [key: string]: string; } = {};

    private types: Array<object> = [
        {value: null, text: 'All'},
        {value: ImportHistoryService.TYPE_CUSTOMERS,      text: 'Customers'},
        {value: ImportHistoryService.TYPE_VENDORS,        text: 'Vendors'},
        {value: ImportHistoryService.TYPE_TRANSACTIONS,   text: 'Transactions'},
        {value: ImportHistoryService.TYPE_LOGS,           text: 'Logs'},
        {value: ImportHistoryService.TYPE_ORDERS,         text: 'Purchase Orders'},
        {value: ImportHistoryService.TYPE_MASTER_DATA,    text: 'Master Data'}
    ];

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private importHistoryService: ImportHistoryService,
        private toastr: ToastrService,
        private title: Title
    ) {
        this.page.pageNumber = 0;
        this.page.size = 100;
        this.title.setTitle('Admin - Import History');
    }

    ngOnInit() {

        this.filters['IH1_CATEGORY'] = ImportHistoryService.CATEGORY_EDI;
        this.selectedCategoryLabel = 'EDI';
        if (this.route.snapshot.params.id) {
            this.filters['IH1_ID'] = this.route.snapshot.params.id;
        }
        this.page.filterParams = this.filters;

        this.loading = true;
        this.importHistoryService.preloadData().subscribe( data => {
            this.preloadedData = data;
            this.prepareData(data);
            this.setPage({offset: 0});
        });
    }

    prepareData(data) {
        this.companies = data.companies.map( company => {
            return {
                CO1_ID: company.CO1_ID,
                text:   company.CO1_NAME
            }
        });
    }

    toggleCategory() {
        if (this.filters['IH1_CATEGORY'] === ImportHistoryService.CATEGORY_EDI) {
            this.filters['IH1_CATEGORY'] = ImportHistoryService.CATEGORY_OES;
            this.selectedCategoryLabel = 'OES';
        } else {
            this.filters['IH1_CATEGORY'] = ImportHistoryService.CATEGORY_EDI;
            this.selectedCategoryLabel = 'EDI';
        }
        this.onSubmit();
    }

    getData() {
        this.loading = true;
        this.setPage({offset: this.page.pageNumber});
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
        this.serverCall(this.page).subscribe(result => {
            const pagedData = this.getPagedData(this.page, result.count, result.data);
            this.page = pagedData.page;
            this.rows = pagedData.data;
            window.dispatchEvent(new Event('resize'));
            this.loading = false;
        },
        error => {
            console.log(error);
            this.loading = false;
            window.dispatchEvent(new Event('resize'));
            this.toastr.error('TimeOut occured', 'Service Error', {
                timeOut: 3000,
            });
        })
    }

    private getPagedData(page: Page,  count: number, data: Array<object>): PagedData<object> {
        const pagedData = new PagedData<object>();
        pagedData.data = data;
        page.totalElements = count;
        page.totalPages = page.totalElements / page.size;
        pagedData.page = page;
        return pagedData;
    }

    serverCall(page: Page): Observable<any> {
        return this.importHistoryService.getItems(page);
    }

    toggleExpandRow(row) {
        if (!row.FILE_CONTENT_LOADED) {
            this.loading = true;
            this.importHistoryService.getById( row.IH1_ID ).subscribe( data => {
                this.loading = false;
                row.IH1_FILE_CONTENT = data;
                row.FILE_CONTENT_LOADED = true;
                this.table.rowDetail.toggleExpandRow(row);
            });
        } else {
            this.table.rowDetail.toggleExpandRow(row);
        }
    }

    onSubmit() {
        const filters = _.clone(this.filters);
        if (filters['CO1_ID'] && parseInt(filters['CO1_ID'], 10) === -1) {
            filters['CO1_ID'] = null;
        }
        this.page.filterParams = filters;
        this.getData();
    }

    clean() {
        this.router.navigate(['import-history-clean']);
    }
}




// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/import-history/import-history.component.ts